import { useTranslation } from 'react-i18next'
import { ModalPresetConfirm, ModalProps } from '@dashboard/ui'
import { dashboardClient } from '@/api'
import { ToastSeverity, useToast } from '@/ui'
import { useGenerateCompanyPath } from '@/libs'

export interface DisableCampaignModalProps extends ModalProps {
  campaignId: string
  action?: string
}

export const DisableCampaignModal = ({ action, campaignId, ...rest }: DisableCampaignModalProps) => {
  const { t } = useTranslation()
  const showToast = useToast()
  const { companyId, gameId } = useGenerateCompanyPath()
  const onConfirm = async () => {
    await dashboardClient.v1.archiveCampaignCreatedObjects(campaignId, companyId, gameId)
    showToast({ message: t('campaign.clean-data.success'), severity: ToastSeverity.success })
    rest.onClose()
  }

  return (
    <ModalPresetConfirm
      {...rest}
      size="md"
      title={{
        children: action ? t('campaign.clean-data.confirm.title') : t('confirm.title'),
        subtitle: action
          ? t('campaign.clean-data.confirm1', {
              action: action,
            })
          : t('campaign.clean-data.confirm.title'),
      }}
      cancel={{
        label: t('campaign.clean-data.button.cancel'),
        callback: rest.onClose,
      }}
      submit={{
        callback: onConfirm,
        color: 'danger',
        label: t('campaign.clean-data.button'),
      }}
    >
      <span className="mt-2">{action && t('campaign.clean-data.confirm2')}</span>
    </ModalPresetConfirm>
  )
}
